import { render } from "./DeleteLabelModal.vue?vue&type=template&id=0d83e779"
import script from "./DeleteLabelModal.vue?vue&type=script&lang=js"
export * from "./DeleteLabelModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__